import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/base/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class HistoryService extends BaseService<any> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public parent(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/parent', { headers: this.headers });
  }

  public parentKey(key: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/parent/' + key, { headers: this.headers });
  }

  public parentKeyDefault(key: string, defaultUrl: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/parent/' + key + '/' + defaultUrl, { headers: this.headers });
  }

  public historyNode(obj: any): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/history-node', obj, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/history';
  }
}
